export default function GetPricingComparisonForBuyerForSellerTermService(
  $log,
  $http,
  $q
) {
  'ngInject';

  return function (args, calculateExactPrice, produceZoomViewValues) {
    console.warn(
      'The getPricingComparisonForBuyerForSellerTermService has been deprecated and will be removed from a future release.'
    );

    return $http.get(
      '/aptitude/buyer/PricingComparisonServiceController/getPricingComparisonForBuyerForSellerTerm',
      {
        params: {
          requestId: args.requestId,
          sellerId: args.sellerId,
          priceType: args.priceType,
          duration: args.duration,
          partnerId: args.partnerId || '',
          calculateExactPrice: calculateExactPrice !== false,
          produceZoomViewValues: produceZoomViewValues !== false
        },
        cache: true,
        intercept: true
      }
    );
  };
}
